module.exports = __webpack_public_path__ + "白子.b6001dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/白子.png
// module id = 115
// module chunks = 2